module.exports = __webpack_public_path__ + "static/placeholder-lg-b118501d3b0d75e917a4ae2e6128b6bb.jpg";